import { render, staticRenderFns } from "./AdminPods.vue?vue&type=template&id=50a1b49c&scoped=true&"
import script from "./AdminPods.vue?vue&type=script&lang=js&"
export * from "./AdminPods.vue?vue&type=script&lang=js&"
import style0 from "./AdminPods.vue?vue&type=style&index=0&id=50a1b49c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a1b49c",
  null
  
)

export default component.exports